import React from 'react';
import ParentContainer from '../ParentContainer';
import ParentContainerV2 from '../ParentContainerV2';

const isLegacyRequested = () => {
  try {
    return (
      new URLSearchParams(globalThis.location.search).get('legacy') === 'true'
    );
  } catch {
    return false;
  }
};

const ParentContainerSelector = () =>
  isLegacyRequested() ? <ParentContainer /> : <ParentContainerV2 />;

export default ParentContainerSelector;
